import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { throttleUntilChanged } from '../../utils/rxjs-utils';
import * as actionType from '../../store/state/actions';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import { ActionManagerInstance } from '../../actions/manager';
import { isErrorActionType } from '../../case/common-helper';
import * as StateManager from '../../store/state/state-manager';
import type { Action } from '../../store/state/state-manager';

import executeDeleteDataObjectRequest from './ async-request';

const deleteDataObject = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];

  return action$.pipe(
    ofType(actionType.DELETE_DATA_OBJECT),
    throttleUntilChanged(100),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((payload) => {
      return executeDeleteDataObjectRequest(payload);
    }),
    mergeMap(async (data: any) => {
      if (data && data.type === actionType.ERROR) {
        const { payload } = data;
        const errorAction = processDataToDispatchErrorAction({ ...data, ...payload, actionMgrID });
        actionsOut.push(errorAction);
        return actionsOut;
      }
      return [];
    }),
    map(() => {
      if (actionsOut.length === 1 && isErrorActionType(actionsOut[0].type)) {
        ActionManagerInstance.rejectActionByID(actionMgrID);
      } else {
        ActionManagerInstance.resolveActionByID(actionMgrID);
      }
      StateManager.dispatch(actionsOut);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export default deleteDataObject;
